import { render, staticRenderFns } from "./TestViewContent.vue?vue&type=template&id=08bad458&scoped=true&"
import script from "./TestViewContent.vue?vue&type=script&lang=js&"
export * from "./TestViewContent.vue?vue&type=script&lang=js&"
import style0 from "./TestViewContent.vue?vue&type=style&index=0&id=08bad458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bad458",
  null
  
)

export default component.exports